<template>
	<div class="investmentClues">
		<leftnav class="fl" mkcode="A" itemcode="A-XZXM"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>
			</el-dialog>
			<div class="index_left_centerpage">
				<!-- 头部盒子开始 -->
				<div class="whitebox right_topbox">
					<div class="right_boxtitle">
						<span class="fl right_title">选址项目</span>
						<!-- <video-teaching :type="3" seat="top"></video-teaching> -->
					</div>
					<!-- 筛选项开始 -->
					<div class="opport-screen-list1" >
						<div class="spage-searchbox ">
							<!-- <ClueNav tabCode="xzxm"></ClueNav> -->
							<dl class="opport-screen bdbe">
								<dt class="fl">产业分类</dt>
								<dd class="fl">
									<span :key="i" v-for="(list,i) in industryList"
										:class="industryCode == list.code?'a-screen current':'a-screen'"
										@click="industryClick(list.code)">{{list.name}}</span>
								</dd>
							</dl>
						</div>
					</div>
					<!-- 筛选项结束 -->
				</div>
				<!-- 头部盒子结束 -->
				<!-- 表格内容开始 -->
				<div class="whitebox">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</p>
						<!-- <p class="fl"   v-if="kwtextsearch">产业大脑为您找到<span 	class="searchnum">{{total}}</span>条【 <span class="orangefont">{{kwtextsearchtext}}</span>】条相关招商情报动态</p> -->
					</div>
					<div class="information_content information_box">
						<div class="infornews" :key="i" v-for="(list,i) in listdata">
							<div @click="routerlinkid('/news',list.id,4)" class="infornews_d">
								<h5 class="title"><span class="fl info_title">{{list.title}}</span><span
										class="fr">{{list.publishTime}}</span></h5>
							</div>
						</div>
					</div>
					<!-- 表格内容结束 -->
					<div class="centerpage1 company_pagelist nojump" v-show="totalPage>1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler">
						</zpagenav>
					</div>
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
		name: 'siteproject',
		computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
		data() {
			return {
				title: "选址项目",
				userdata: {},
				curWebsite: this.$api.getWebsiteType(),
				industryList: [],
				industryCode: 0,
				listdata: [],
				orderField: 5, //排序字段 0 分数 1 时间
				orderType: 0, //排序方式 0 降序 1 升序  
				page: 1, //显示的是哪一页
				haspage: true, //是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 100, //记录总数 
				totalPage: 1,
				maxPage: 10, //最大页数  
				isShowFreeUserTips: false,
			}
		},
		created() {
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
			this.userdata = this.getuseriformation();
			// this.userdata.groupType=0;
			// this.getcompanylist(); 
			this.getIndustryList();
			this.getcompanylist()
			  
		},
		mounted() {

			// document.getElementById('app').style.background = "#f0f3f5";
		},
		methods: {
			industryClick(code){
				if(!this.userdata.token){
					this.isShowFreeUserTips = true;
					return;
				}
				this.industryCode=code;
				this.getcompanylist();
			}, 
			//获取选址项目自定义产业分类
			getIndustryList() {
				var ajaxurl = this.$api.cyl.projectnews.paramList(),
					_this = this;
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					_this.industryList = res.data.list;
					_this.industryList.unshift({
						code: 0,
						name: '全部'
					});
				}).catch(function(error) {});
			},
			//获取选址项目线索
			getcompanylist(paged) {
				this.bus.$emit('loading', true);
				this.page = paged ? paged : 1;
				var _this = this;
				var notionja = this.splicing('notionCode', this.industryCode);
				var ajaxurl = this.$api.cyl.projectnews.list() + '?page=' + this.page + notionja;
				console.log(ajaxurl)
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log(res.data.list);
					_this.listdata = res.data.list;
					_this.totalPage = res.data.totalPage;
					_this.pageSize = res.data.pageSize;
					_this.total = res.data.totalRecord;
					_this.bus.$emit('loading', false);
				}).catch(function(error) {});
			},
			//时间/分数升降序
			tablesort(field) {
				if (field == this.orderField) {
					this.orderType = Math.abs(this.orderType - 1);
				} else {
					this.orderField = field;
				}
				this.getcompanylist();
			},
			// pageHandler: function (page) {
			// 	this.page = page; 
			// 	this.getcompanylist(page); 
			// },
			pageHandler: function(page) {
				this.getcompanylist(page);
			},
			jsondouhao(name, data) {
				if (data.length > 0) {
					var notionja = "";
					if (data.length != 0) {
						var douhao = '%2C';
						for (var i = 0; i < data.length; i++) {
							if (i == data.length - 1) {
								douhao = '';
							}
							notionja += data[i].id + douhao;
						}
						notionja = '&' + name + '=' + notionja;
						return notionja;
					}
				} else {
					return "";
				}
			},
		},
	}
</script>

<style>
	/* 提示框箭头 */
	.atooltip.el-tooltip__popper[x-placement^="top"] .popper__arrow {
		border-top-color: #E0E8F9;
	}

	.atooltip.el-tooltip__popper[x-placement^="top"] .popper__arrow:after {
		border-top-color: #E0E8F9;
	}

	/* 提示框背景色 */
	.atooltip {
		background: #E0E8F9 !important;
	}


	.a-red {
		color: #c00;
	}

	.nojump .jump {
		display: none;
	}
</style>